import * as pickupService from '@features/pickups/services/pickupService';
import {
  useQuery,
  useMutation,
  useQueryClient,
  useInfiniteQuery,
} from "@tanstack/react-query";

export function usePickups() {
  const queryClient = useQueryClient();

  const { data: pickups, isLoading } = useQuery({
    queryKey: ["pickups"],
    queryFn: pickupService.fetchAllPickups,
  });

  const createMutation = useMutation({
    mutationFn: pickupService.createPickup,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pickups"] });
    },
  });

  const updateMutation = useMutation({
    mutationFn: pickupService.updatePickup,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pickups", "pickup"] });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: pickupService.deletePickup,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pickups"] });
    },
  });

  return {
    pickups,
    isLoading,
    createPickup: createMutation.mutate,
    updatePickup: updateMutation.mutate,
    deletePickup: deleteMutation.mutate,
    createPickupLoading: createMutation.isLoading,
    updatePickupLoading: updateMutation.isLoading,
    deletePickupLoading: deleteMutation.isLoading,
  };
}

export const usePickupsInfiniteQuery = (params) => {
  const searchParams = new URLSearchParams(params);
  return useInfiniteQuery({
    queryKey: ["pickups", params],
    queryFn: async ({ pageParam }) => {
      return pickupService.fetchAllPickups(
        `page=${pageParam}&${searchParams.toString()}`
      );
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      return lastPage.pageInfo.nextPage !== null
        ? lastPage.pageInfo.nextPage
        : undefined;
    },
  });
};
